{
    "TelnosmovedtoLabel": "Número(s) de telefone movido(s) para:",
    "DevicesmovedfromLabel": "Dispositivo(s) movido(s) de:",
    "AcdagentsmovedfromLabel": "Agente(s) de ACD movidos de:",
    "CallsegmentnumberLabel": "Número do segmento de chamada:",
    "CallsegmentnumberAnyOptionLabel": "[Any]",
    "CallsegmentnumberFirstOptionLabel": "[Primeiro]",
    "Callsegmentnumber2OptionLabel": "2",
    "Callsegmentnumber3OptionLabel": "3",
    "Callsegmentnumber4OptionLabel": "4",
    "Callsegmentnumber5OptionLabel": "5",
    "Callsegmentnumber6plusOptionLabel": "6+",
    "CallsegmentnumberLastOptionLabel": "[Último]",
    "CallsegmentstartreasonLabel": "Motivo de início do segmento de chamada:",
    "CallsegmentstartreasonAnyOptionLabel": "[Any]",
    "CallsegmentstartreasonDivertedtoOptionLabel": "Desviado para",
    "CallsegmentstartreasonOverflowedinOptionLabel": "Em sobrecarga",
    "CallsegmentstartreasonAdvancedtoOptionLabel": "Avançado para",
    "CallsegmentstartreasonTransferredtoOptionLabel": "Transferido para",
    "CallsegmentstartreasonConferencedtoOptionLabel": "Conferência para",
    "CallsegmentstartreasonConferencedegenOptionLabel": "Conferência De\/Gen",
    "CallsegmentendreasonLabel": "Motivo de fim do segmento de chamada:",
    "CallsegmentendreasonAnyOptionLabel": "[Any]",
    "CallsegmentendreasonDivertedfromOptionLabel": "Desviado de",
    "CallsegmentendreasonOverflowedoffOptionLabel": "Em sobrecarga",
    "CallsegmentendreasonAdvancedfromOptionLabel": "Avançado de",
    "CallsegmentendreasonTransferredfromOptionLabel": "Transferido de",
    "CallsegmentendreasonConferencedfromOptionLabel": "Conferência de",
    "CallsegmentendreasonConferencedegenOptionLabel": "Conferência De\/Gen",
    "CallsegmentendreasonConsultationtrtoOptionLabel": "Consulta Tr\/To",
    "CallsegmentendreasonMovedtoconferenceOptionLabel": "Movido para a conferência",
    "CallsegmentendreasonMovedtoparkOptionLabel": "Movido para parqueamento",
    "CallsegmentendreasonMovedtovoicemailOptionLabel": "Movido para o correio de voz",
    "CallsegmentendreasonEndedonholdonlyOptionLabel": "Terminado apenas em espera",
    "CallsegmentendreasonEndedonholdexclOptionLabel": "Encerrado em espera Removido",
    "CallsegmentendreasonUnmonitoreddestOptionLabel": "Destino não monitorizado",
    "CallsegmentendreasonUnknowndestOptionLabel": "Destino desconhecido",
    "CallsegmentendreasonAllunrslvddestonlyOptionLabel": "Apenas todos os destinos não resolvidos",
    "CallsegmentendreasonAllunrslvddestexclOptionLabel": "Todos os destinos não resolvidos removidos",
    "CallsegmentendreasonModellingerrorsonlyOptionLabel": "Erros de modelação apenas",
    "CallsegmentendreasonModellingerrorsexclOptionLabel": "Erros de modelação removidos",
    "CallsegmentendreasonApplicationendedOptionLabel": "Aplicação terminada",
    "CallsegmentendreasonDevicedeletedOptionLabel": "Dispositivo removido",
    "CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel": "E-mails sem necessidade de resposta removidos",
    "CallsegmentchainidLabel": "ID da cadeia do segmento de chamada (ID de chamada da aplicação):",
    "CallMovementFiltering_SectionHeader": "Filtragem de Movimento de Chamada",
    "CallMovementFiltering_AnyPlaceholder": "[Any]",
    "NAME": "CallMovementFiltering",
    "AcdagentsmovedfromLabel_MST": "Agente(s) transferido(s) de:",
    "CallsegmentstartreasonEscapedtoOptionLabel": "Fugiu para",
    "CallsegmentendreasonEscapedfromOptionLabel": "Fugiu",
    "CallsegmentnumberFirstAfterFilteringOptionLabel": "[Primeiro - Após a Filtragem]",
    "CallsegmentnumberLastAfterFilteringOptionLabel": "[Último - Após a Filtragem]",
    "CallsegmentStartEndReasonSupervisorTransferOptionLabel": "Transferência de supervisor"
}